// src/utils/money.js
export const toCents = (v) => {
    if (v === null || v === undefined || v === "") return 0;
    const n = Number(String(v).replace(",", "."));
    return Number.isFinite(n) ? Math.round(n * 100) : 0;
};

export const fromCents = (c) => {
    const n = Number(c || 0);
    return (n / 100).toFixed(2);
};
